
import React from 'react';
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardFooter, 
  CardHeader, 
  CardTitle 
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface ContactCardProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  content: React.ReactNode;
  action: React.ReactNode;
  buttonText: React.ReactNode;
  href?: string;
  onClick?: () => void;
}

const ContactCard = ({ icon, title, content, action, buttonText, href, onClick }: ContactCardProps) => (
  <Card>
    <CardHeader>
      <div className="flex items-center gap-2">
        {icon}
        <CardTitle>{title}</CardTitle>
      </div>
      <CardDescription>{content}</CardDescription>
    </CardHeader>
    <CardContent>
      <p className="font-medium text-lg">{action}</p>
    </CardContent>
    <CardFooter>
      {href ? (
        <Button asChild variant="outline" className="w-full">
          <a href={href}>{buttonText}</a>
        </Button>
      ) : (
        <Button variant="outline" className="w-full" onClick={onClick}>
          {buttonText}
        </Button>
      )}
    </CardFooter>
  </Card>
);

export default ContactCard;
